import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function StaticPages() {
  const navigate = useNavigate();
  const pages = [{
    id: 1,
    title: 'About Us',
    text: 'Learn about our history...',
    param: 'about-us'
  }, {
    id: 2,
    title: 'Privacy Policy',
    text: 'Your privacy matters...',
    param: 'privacy'
  }, {
    id: 3,
    title: 'Terms of Service',
    text: 'Please read carefully...',
    param: 'terms'
  }];
  return <div className="space-y-4" data-id="element-1574">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1575">Static Pages</h1>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1576">
        <div className="overflow-x-auto" data-id="element-1577">
          <table className="w-full text-sm text-left" data-id="element-1578">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1579">
              <tr data-id="element-1580">
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1581">Title</th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1582">Text</th>
                <th className="px-3 py-3 border-r border-slate-700 w-32" data-id="element-1583">
                  Param
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1584">
                  <div data-id="element-1585">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1586">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1587">
              {pages.map(page => <tr key={page.id} className="hover:bg-slate-50" data-id="element-1588">
                  <td className="px-3 py-2.5 border-r border-slate-200 font-medium" data-id="element-1589">
                    {page.title}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600 truncate max-w-xs" data-id="element-1590">
                    {page.text}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 font-mono text-xs" data-id="element-1591">
                    {page.param}
                  </td>
                  <td className="px-3 py-2.5 text-center" data-id="element-1592">
                    <div className="flex items-center justify-center gap-2" data-id="element-1593">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/static-pages/view/${page.id}`)} data-id="element-1594">
                        <Eye className="h-4 w-4" data-id="element-1595" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/static-pages/edit/${page.id}`)} data-id="element-1596">
                        <Edit className="h-4 w-4" data-id="element-1597" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1598">
                        <Trash2 className="h-4 w-4" data-id="element-1599" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}